var _a, _b;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import ActionsFunctionView from './ActionsFunctionView.html';
import { FunctionViewModel } from '../../../../models/viewModels/FunctionViewModel';
import { BuilderSegmentService } from '../../../../services/BuilderSegmentService';
import { ActionService } from '../../../../services/ActionService';
let ActionsFunctionComponent = class ActionsFunctionComponent {
    static $inject = ['BuilderSegmentService', 'PipelineActionService'];
    constructor(BuilderSegmentService, PipelineActionService) {
        'ngInject';
        this.PipelineActionService = PipelineActionService;
        this.CREATE_FUNCTION_SCREEN = 'createFunction';
        this.MANAGE_FUNCTION_SCREEN = 'manageFunction';
        this.MAIN_SCREEN = '';
        this.PipelineBuilderSegmentService = BuilderSegmentService;
    }
    $onInit() {
        this.actions = new FunctionViewModel();
        this.activeComponent = this.MAIN_SCREEN;
    }
    $onChanges(changes) {
        if (changes.actions) {
            this.actions = changes.actions.currentValue;
        }
    }
    handleActiveComponent(component) {
        if (component === this.CREATE_FUNCTION_SCREEN) {
            this.PipelineActionService.setStatusNewFunction(true);
            this.PipelineActionService.setState('');
            this.actions.sourceScreen = this.MAIN_SCREEN;
            this.PipelineActionService.setActions(this.actions);
        }
        this.setActiveComponent(component);
    }
    setActiveComponent(component) {
        switch (component) {
            case 'manageFunction':
                this.PipelineBuilderSegmentService.trackBlockActionOpenLibrary({
                    Location: 'Library',
                    Description: 'Quando o usuário clica no botão Criar função ao preencher os campos de uma nova função',
                });
                break;
            case 'createFunction':
                this.PipelineBuilderSegmentService.trackBlockActionLibraryCreateFunction({
                    Description: 'Quando o usuário clica no botão ’Expandir conteúdo’ dentro da criação/edição/visualização de uma função',
                });
                break;
            default:
                break;
        }
        this.activeComponent = component;
    }
    onActionChange() {
        this.onActionChanged({ actions: this.actions });
    }
    deleteAction() {
        this.onActionDeleted({ actions: this.actions });
    }
};
ActionsFunctionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: ActionsFunctionView,
        bindings: {
            actions: '<',
            onActionChanged: '&',
            onActionDeleted: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _a : Object, typeof (_b = typeof ActionService !== "undefined" && ActionService) === "function" ? _b : Object])
], ActionsFunctionComponent);
export { ActionsFunctionComponent };
